export const API_URL = process.env.NEXT_PUBLIC_API_URL || "https://api-dev.nitrosimracing.com.co";
const DEFAULT_TIMEOUT_MS = 12000;

export async function apiFetch(path, options = {}) {
  if (typeof window === "undefined" && process.env.NITRO_BUILD_OFFLINE === "1") {
    const error = new Error("Las solicitudes HTTP están deshabilitadas durante el build offline.");
    error.code = "NITRO_BUILD_OFFLINE";
    throw error;
  }

  const { timeoutMs = DEFAULT_TIMEOUT_MS, signal, ...fetchOptions } = options;
  const effectiveTimeoutMs = typeof timeoutMs === "number" && Number.isFinite(timeoutMs) && timeoutMs > 0
    ? timeoutMs
    : DEFAULT_TIMEOUT_MS;
  const controller = new AbortController();
  let timedOut = false;
  const timeout = setTimeout(() => {
    timedOut = true;
    controller.abort();
  }, effectiveTimeoutMs);
  const abortFromCaller = () => controller.abort(signal?.reason);

  if (signal) {
    if (signal.aborted) {
      abortFromCaller();
    } else {
      signal.addEventListener("abort", abortFromCaller, { once: true });
    }
  }

  let response;
  let data;
  try {
    response = await fetch(`${API_URL}${path}`, {
      ...fetchOptions,
      credentials: "include",
      signal: controller.signal,
      headers: normalizedHeaders(fetchOptions.headers),
    });
    try {
      data = await response.json();
    } catch (error) {
      if (error?.name === "AbortError") throw error;
      if (response.ok) {
        const invalidResponse = new Error("Nitro devolvió una respuesta inválida.");
        invalidResponse.code = "NITRO_INVALID_RESPONSE";
        throw invalidResponse;
      }
      data = {};
    }
  } catch (error) {
    if (error.name === "AbortError" && timedOut) {
      throw new Error("La conexion con Nitro esta tardando demasiado. Intenta actualizar la pagina.");
    }
    throw error;
  } finally {
    clearTimeout(timeout);
    signal?.removeEventListener("abort", abortFromCaller);
  }

  if (!response.ok) {
    const error = new Error(data?.error?.message || "No se pudo completar la solicitud.");
    error.details = data?.error?.details || null;
    error.code = data?.error?.code || data?.error?.details?.code || null;
    error.status = response.status;
    throw error;
  }

  return data;
}

function normalizedHeaders(input) {
  const headers = new Headers(input);
  if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  return headers;
}
